module.exports = __webpack_public_path__ + "img/24-3.d3a2b101.jpg";